module.exports = __webpack_public_path__ + "img/010.caaec364.png";